import { render, staticRenderFns } from "./TitleBarRevision.vue?vue&type=template&id=3baaf18a&scoped=true"
import script from "./TitleBarRevision.vue?vue&type=script&lang=js"
export * from "./TitleBarRevision.vue?vue&type=script&lang=js"
import style0 from "./TitleBarRevision.vue?vue&type=style&index=0&id=3baaf18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baaf18a",
  null
  
)

export default component.exports